import { useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import React, { useState } from "react";
import { useGetEnrollmentListQuery, useGetAdminGroupListQuery, useGetStudentListQuery, useAddAsignBatchMutation, useGetCourseListQuery, useGetLearningOutcomeListQuery } from "../../../Services/api";
import { MultiSelect } from "react-multi-select-component";

export default function Create() {
    const notify = () => '';

    const { register, handleSubmit, setValue, formState: { errors } } = useForm();
    const [studentId, setStudentId] = useState([]);
    const nameToHandler = (value) => {
        setValue("student_id", value[0]?.value);
        setStudentId([...value])
    }

    const [addAsignBatch, isLoading] = useAddAsignBatchMutation();
    const onSubmit = (values, e) => {

        values.participant_group = values.batch
        values.course_id = values.course_id
        values.student_id = values.student_id
        console.log('values', values);
        addAsignBatch(values)
            .unwrap()
            .then((payload) => {
                if (payload.status) {
                    e.target.reset()
                    toast.success(payload.message)
                } else {
                    toast.error(payload.message)
                }
            })
            .catch((error) => {
                toast.error(error.data.message)
            });
        notify();
    };
    const {
        data: getCourseList
    } = useGetCourseListQuery({ params: '' });
    const {
        data: StudentList
    } = useGetStudentListQuery();
    const {
        data: getAdminGroupList
    } = useGetAdminGroupListQuery({ params: '' });
    const [courseId, setCourseId] = useState(0);
    const [elementId, setElementId] = useState(0);
    const findLession = (e) => {
        setCourseId(e.target.value);
    }
    const findElementId = (e) => {
        setElementId(e.target.value);
    }
    const {
        data: LearningOutcomeList
    } = useGetLearningOutcomeListQuery({ params: courseId });
    const {
        data: getEnrollmentList
    } = useGetEnrollmentListQuery({ params: { course_id: courseId, element: elementId } });

    return (
        <div className="tab-pane fade" id="bordered-justified-profile" role="tabpanel" aria-labelledby="profile-tab" >
            <section className="section">
                <div className="card">
                    <div className="card-body">
                        <h5 className="card-title">Add Batch Information</h5>
                        <form onSubmit={handleSubmit(onSubmit)} >
                            <div className="row mb-3">
                                <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Course</label>
                                <div className="col-sm-10">
                                    <select  {...register("course_id", { required: true })} className="form-control" onChange={findLession}>
                                        <option value="">Select Course</option>
                                        {
                                            getCourseList?.data?.map((item) => {
                                                return (
                                                    <option key={item.course_id} value={item.course_id}>{item.course_name}</option>
                                                )
                                            })
                                        }
                                    </select>
                                    {errors.course_id && <span className="text-danger">Course is required</span>}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Element</label>
                                <div className="col-sm-10">
                                    <select  {...register("lpid", { required: true })} className="form-control" onChange={findElementId}>
                                        <option value="">Select Element</option>
                                        {
                                            LearningOutcomeList?.data?.map((item) => {
                                                return (
                                                    <option key={item.lpid} value={item.lpid}>{item.element_name}</option>
                                                )
                                            })
                                        }
                                    </select>
                                    {errors.lpid && <span className="text-danger">Course is required</span>}
                                </div>
                            </div>

                            <div className="row mb-3">
                                <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">student</label>
                                <div className="col-sm-10">
                                    <MultiSelect
                                        options={
                                            Array.isArray(getEnrollmentList?.data)
                                                ? getEnrollmentList?.data?.map(({ student }) => ({
                                                    label: `${student?.first_name} ${student?.last_name} (${student?.email})`,
                                                    value: student?.student_id,
                                                }))
                                                : []
                                        }
                                        value={studentId}
                                        onChange={nameToHandler}
                                        labelledBy="Select"
                                    />
                                    {errors.student_id && <span className="text-danger">Student is required</span>}

                                </div>
                            </div>
                            <div className="row mb-3">
                                <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Batch</label>
                                <div className="col-sm-10">
                                    <select  {...register("batch", { required: true })} className="form-control">
                                        <option value="">Select Batch</option>
                                        {
                                            getAdminGroupList?.data?.map((item) => {
                                                return (
                                                    <option key={item.id} value={item.id}>{item.title}</option>
                                                )
                                            })
                                        }
                                    </select>
                                    {errors.batch && <span className="text-danger">Batch is required</span>}
                                </div>
                            </div>
                            <div className="modal-footer">

                                {isLoading.status !== 'pending' ?
                                    <>
                                        <button type="submit" className="btn btn-warning">Save changes</button>
                                    </>
                                    :
                                    <button type="submit" className="btn btn-warning w-100" ><div className="spinner-border text-muted"></div></button>
                                }
                            </div>

                        </form>
                    </div>
                </div>
            </section>
        </div>
    );
}